import { Select, TextField } from '@nike/eds';
import { useSearchParams } from 'react-router-dom';
import * as R from 'ramda';

export const searchOptionsVerToSelectOpts = (
  searchOptsVer: SearchOptionsVersion[],
) => {
  const filterSearchOptsVer = searchOptsVer.filter((v) => !v.hide);
  return R.map((ver) => {
    return {
      label: `Ver.${ver.searchVersionNumber}:${JSON.stringify(
        ver.searchOptions,
      )}`,
      value: ver.searchVersionNumber,
    };
  }, filterSearchOptsVer);
};
export const searchOptionsVerToVerMap = (
  searchOptsVer: SearchOptionsVersion[],
) => {
  const groupByVer = R.groupBy(R.prop('searchVersionNumber'), searchOptsVer);
  return R.map((v) => v && v[0], groupByVer);
};

export const setSearchOptionsToURLSearchParams = (
  searchOptions: keyable,
  searchParams: URLSearchParams,
) => {
  for (const key in searchOptions) {
    searchParams.set(key, searchOptions[key]);
  }
  return searchParams;
};

export const unsetSearchOptionsToURLSearchParams = (
  searchOptions: keyable,
  searchParams: URLSearchParams,
) => {
  for (const key in searchOptions) {
    searchParams.delete(key);
  }
  return searchParams;
};

export function SearchOptions(props: any) {
  const { searchOptions, setSearchOptions } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const searchOptionsView = searchParams.get('searchOptionsView') === '1';
  const searchSelect: SearchSelect[] = props.searchSelectOptionsData;
  return (
    <>
      {searchSelect &&
        searchSelect.map(
          (option, index) =>
            (option.dependsOn == undefined ||
              (option.dependsOn.key !== undefined &&
                searchOptions[option.dependsOn.key] ===
                  option.dependsOn.value)) && (
              <Select
                id={`${option.key}-select-${index}`}
                key={`${option.key}-select-${index}`}
                className='tw-w-60 tw-rounded-3xl'
                label={option.label}
                options={option.options}
                value={
                  option.options.filter(
                    (v) => v.value === props.searchOptions[option.key],
                  )[0]
                }
                onChange={(event) => {
                  setSearchOptions({
                    ...searchOptions,
                    [option.key]: event?.value,
                  });
                  if (searchOptionsView) {
                    searchParams.set(option.key, event?.value || '');
                    setSearchParams(searchParams);
                  }
                }}
              />
            ),
        )}

      {searchOptions['rankingServiceStrategy'] === 'ltr' && (
        <TextField
          id='upmid'
          type='text' // default type
          label='UPMID'
          placeholder='Please input Prod UPMID'
          onChange={(event) => {
            const { target } = event;
            const val = (target as HTMLInputElement).value;

            setSearchOptions({
              ...searchOptions,
              upmid: val,
            });

            if (searchOptionsView) {
              searchParams.set('upmid', val);
              setSearchParams(searchParams);
            }
          }}
        />
      )}
    </>
  );
}
